<style lang="sass" rel="stylesheet/sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/stickyMenuBar
</style>

<template>
    <div
        :style="customStyle"
        :class="{ 'sticky': isSticky }"
        class="sticky_menu_bar">
        <Grid
            class="g_center"
            type="ul">
            <GridItem
                :key="index"
                v-for="(menu, index) in menus">
                <div class="g_imageContent">
                    <div
                        class="g_image"
                        v-img-src.sync="{ project: false, folder: 'compare/machines', name: menu.image, ext: 'png' }"
                        v-if="isSticky"/>
                    <div class="g_image" v-if="!isSticky">
                        <img
                            v-img-src.sync="{ project: false, folder: 'compare/machines', name: menu.image, ext: 'png' }" />
                    </div>
                    <Heading
                        :level="4"
                        v-html="menu.txt" />
                </div>
            </GridItem>
        </Grid>
    </div>
</template>

<script>
// Lib
import 'core-js/fn/array/fill'
// Component
import Heading from 'gvue/src/core/Heading'
import { Grid, GridItem } from 'gvue/src/core/Grid'
import throttle from 'nespresso-library/src/utils/throttle'

import { position, outerHeight } from 'gaspard'

export default {
    name: 'StickyMenuBar',
    components: {
        Heading,
        Grid,
        GridItem
    },
    props: {
        elTab: {
            type: HTMLDivElement
        },
        menus: {
            type: Array
        }
    },
    data () {
        return {
            isSticky: {
                type: Boolean,
                default: false
            },
            activeButton: {
                type: Boolean,
                default: false
            },
            menuLink: {
                type: String,
                default: ''
            },
            sectionsIds: {
                type: Array,
                default: []
            },
            customStyle: {
                type: String,
                default: ''
            },
            initialStickyMenuBarHeight: null
        }
    },
    mounted () {
        this.setSticky()
        this.scrollEvent()
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollEvent)
    },
    watch: {
        '$root.$json' () {
            this.$nextTick(() => {
                this.initialStickyMenuBarHeight = outerHeight(this.$el, true)
            })
        },
        isSticky () {
            if (this.isSticky) {
                this.setPositionStickyBar()
            } else {
                this.customStyle = `top:inherit`
                this.$emit('changeState', 'inherit')
            }
        }
    },
    methods: {
        scrollEvent () {
            const compareElOffsetTop = (this.elTab ? this.elTab.getBoundingClientRect().top : 0) + (window.scrollY || window.pageYOffset)
            this.isSticky = this.elTab && !!(window.pageYOffset >= compareElOffsetTop)
        },
        setActiveMenu (menuLink) {
            this.activeButton = true
            this.menuLink = menuLink
        },
        setSticky: function () {
            window.addEventListener('scroll', throttle(() => this.scrollEvent(), 10), { passive: true })
        },
        setPositionStickyBar () {
            let el = document.querySelector('.Header__top-wrapper')
            const pos = position(el)
            let top = 0
            top = pos.top
            let positionTop = top + outerHeight(el, true)
            this.customStyle = `top:${positionTop}px`
            const padding = this.initialStickyMenuBarHeight + outerHeight(this.$el, true)
            this.$emit('changeState', `${padding}px`)
        }
    }
}
</script>`
